import { api } from '@/store/api'
import type { McpConnection, OAuthPending, OAuthRedirect } from './types'

export const mcpApi = api.injectEndpoints({
  endpoints: (build) => ({
    getOAuthPending: build.query<OAuthPending, string>({
      query: (txn) => `authors/oauth/pending?txn=${encodeURIComponent(txn)}`,
    }),
    approveOAuth: build.mutation<OAuthRedirect, { txn: string }>({
      query: (body) => ({ url: 'authors/oauth/approve', method: 'POST', body }),
    }),
    denyOAuth: build.mutation<OAuthRedirect, { txn: string }>({
      query: (body) => ({ url: 'authors/oauth/deny', method: 'POST', body }),
    }),
    getConnections: build.query<McpConnection[], void>({
      query: () => 'authors/connections',
      providesTags: ['Connection'],
    }),
    revokeConnection: build.mutation<void, string>({
      query: (clientId) => ({
        url: `authors/connections/${encodeURIComponent(clientId)}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Connection'],
    }),
  }),
})

export const {
  useGetOAuthPendingQuery,
  useApproveOAuthMutation,
  useDenyOAuthMutation,
  useGetConnectionsQuery,
  useRevokeConnectionMutation,
} = mcpApi
